export const borderTypes = {
    bottom: 'bottom',
    full: 'full',
    none: 'none',
};
export const labelTypes = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
export const sizes = {
    medium: 'medium',
    small: 'small',
};
